<template>
  <div class="dn-theme-switch-wrapper">
    <label
      class="dn-theme-switch"
      for="theme-switch-checkbox"
    >
      <input
        id="theme-switch-checkbox"
        v-model="isDarkMode"
        type="checkbox"
      >
      <div class="slider">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="var(--color-brand-utility-50)"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="feather feather-sun"
        >
          <circle
            cx="12"
            cy="12"
            r="5"
          />
          <line
            x1="12"
            y1="1"
            x2="12"
            y2="3"
          />
          <line
            x1="12"
            y1="21"
            x2="12"
            y2="23"
          />
          <line
            x1="4.22"
            y1="4.22"
            x2="5.64"
            y2="5.64"
          />
          <line
            x1="18.36"
            y1="18.36"
            x2="19.78"
            y2="19.78"
          />
          <line
            x1="1"
            y1="12"
            x2="3"
            y2="12"
          />
          <line
            x1="21"
            y1="12"
            x2="23"
            y2="12"
          />
          <line
            x1="4.22"
            y1="19.78"
            x2="5.64"
            y2="18.36"
          />
          <line
            x1="18.36"
            y1="5.64"
            x2="19.78"
            y2="4.22"
          />
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="var(--color-brand-utility-900)"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="feather feather-moon"
        >
          <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
        </svg>
      </div>
    </label>
  </div>
</template>
<script setup lang="ts">
import { ref } from 'vue';
const colorMode = useColorMode();
const isDarkMode = ref(colorMode.preference === 'dark');

watch(isDarkMode, (newVal) => {
  colorMode.preference = newVal ? 'dark' : 'light';
});
</script>

<style lang="scss">
/* TOGGLE  */
.dn-theme-switch-wrapper {
  border-radius: var(--box-radius);
  height: 34px;
}

.dn-theme-switch {
  display: inline-block;
  height: 34px;
  position: relative;
  width: 60px;

  & input {
    display: none;
  }
}

.slider {
  background-color: var(--color-brand-utility-50);
  inset: 0;
  cursor: pointer;
  position: absolute;
  transition: 0.4s;
  border-radius: 34px;
}

.slider::before {
  background-color: var(--color-brand-utility-50);
  bottom: 4px;
  content: '';
  height: 26px;
  left: 4px;
  position: absolute;
  transition: 0.4s;
  width: 26px;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: var(--color-brand-utility-50);
}

input:checked + .slider::before {
  transform: translateX(26px);
}

.slider svg {
  color: var(--color-brand-utility-900);
  position: absolute;
  transition: opacity 0.2s ease 0s, transform 0.35s ease 0s;
  pointer-events: none;
}

.feather-moon {
  opacity: 0;
  left: 9px;
  bottom: 9px;
  transform: translateX(4px);
}

.feather-sun {
  opacity: 1;
  right: 10px;
  bottom: 9px;
  transform: translateX(0px);
}

input:checked + .slider .feather-moon {
  opacity: 1;
  transform: translateX(0);
}

input:checked + .slider .feather-sun {
  opacity: 0;
  transform: translateX(-4px);
}
</style>
